
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emporium/apostle/list",
      function () {
        return require("private-next-pages/emporium/apostle/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emporium/apostle/list"])
      });
    }
  